/** Feedback list (temporary client tracker; hidden unless the server has it switched on). */
import {
  FEEDBACK_PRIORITIES,
  FEEDBACK_TABS,
  FEEDBACK_TYPES,
} from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import {
  FeedbackListPage,
  type FeedbackListSearch,
} from "@/features/feedback/components/feedback-list-page";

const search = z.object({
  tab: z.enum(FEEDBACK_TABS).optional().catch(undefined),
  type: z.enum(FEEDBACK_TYPES).optional().catch(undefined),
  priority: z.enum(FEEDBACK_PRIORITIES).optional().catch(undefined),
  unassigned: z.boolean().optional().catch(undefined),
  involving: z.boolean().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/feedback/")({
  validateSearch: search,
  beforeLoad: () => {
    const { me, can } = useAuth.getState();
    if (!me?.features?.feedback || !can("feedback.view"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onSearch = useCallback(
    (next: Partial<FeedbackListSearch>) =>
      void navigate({ search: (prev) => ({ ...prev, ...next }) }),
    [navigate]
  );
  return <FeedbackListPage search={s} onSearch={onSearch} />;
}
